var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.00004H13.25M11.9167 4.00004V13.3334C11.9167 14 11.25 14.6667 10.5833 14.6667H3.91667C3.25 14.6667 2.58333 14 2.58333 13.3334V4.00004M4.58333 4.00004V2.66671C4.58333 2.00004 5.25 1.33337 5.91667 1.33337H8.58333C9.25 1.33337 9.91667 2.00004 9.91667 2.66671V4.00004",
    stroke: "#6F6F6F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.45806720fb691d4080279015a222878e.svg";
export { ForwardRef as ReactComponent };